<template>
  <div class='client-preference-results'>
    <ClientPreferenceResults
      :screenSets='screenSetsWithMetricInfo'
      :assignedColors='assignedColors'
      :prospect='prospect'
      :features='features'/>
  </div>
</template>


<script>
import ClientPreferenceResults from './ClientPreferenceResults.vue';
import { getScreenSets, getMetrics } from '@frontend/api/api.js';
import { useAdvisorStore } from '@frontend/ui/stores/advisorStore.js';
import { mapStores } from 'pinia';

export default {
  name: 'client-preference-results',
  components: { ClientPreferenceResults },
  props: ['advisor', 'features'],
  data() {
    return {
      screenSets: [],
      metrics: [],
      prospectID: null,
      prospect: null,
    };
  },
  beforeCreate() {},
  created() {},
  mounted() {
    this.setScreenSets();
    this.setMetrics();
    this.getProspectID();
  },
  updated() {},
  computed: { /*
    Creates a new property
    Updates when any dependant property changes */
    ...mapStores(useAdvisorStore),
    metricsHash() {
      const hash = {};

      this.metrics.forEach((metric) => {
        hash[metric.id] = metric;
      });
      return hash;
    },
    namedScreenSets() {
      return this.screenSets.filter((screenSet) => screenSet.issue_name);
    },
    wizardScreenSets() {
      return this.advisor?.firm.preferences.wizard_screen_sets;
    },
    screenSetsWithProspectMetrics() {
      let sets;
      if(this.wizardScreenSets?.length > 0) {
        sets = this.wizardScreenSets;
      }
      else {
        sets = this.namedScreenSets;
      }

      // Return all screensets but filter metrics so only those found in prospectMetricHash are included
      return sets.map((screenSet) => {
        const metrics = screenSet.metrics.filter((metric) => {
          return this.prospectMetricHash[metric.metric_description];
        });
        return { ...screenSet, metrics };
      });
    },
    filteredScreenSets() {
      // Filter screensets so only those with at least one metric are included
      return this.screenSetsWithProspectMetrics.filter((screenSet) => {
        return screenSet.metrics.length > 0;
      });
    },
    screenSetsWithMetricInfo() {
      if (!this.filteredScreenSets) return [];
      return this.filteredScreenSets.map((screenSet) => {
        const metrics = screenSet.metrics.map((metric) => {
          const info = this.metricsHash[metric.metric_description];
          return { ...metric, info };
        });
        return { ...screenSet, metrics };
      });
    },
    prospectScreenSetID() {
      return this.prospect?.screen_sets[0].id;
    },
    prospectScreenSet() {
      return this.screenSets?.find((set) => {
        return set.id === this.prospectScreenSetID;
      });
    },
    prospectMetricHash() {
      const hash = {};

      this.prospectScreenSet?.metrics.forEach((metric) => {
        hash[metric.metric_description] = metric;
      });
      return hash;
    },
    colors() {
      return this.$root.$data.COLORS.assorted;
    },
    assignedColors() {
      const assigned = {};
      if (!this.screenSetsWithMetricInfo) return {};

      this.screenSetsWithMetricInfo.forEach((set, i) => {
        const n = i % this.colors.length;
        assigned[set.issue_name] = this.colors[n];
      });
      return assigned;
    },
  },
  watch: { /*
    Watches an existing property
    Only runs when the watched property changes */
    prospectID() {
      this.getProspect();
    },
  },
  methods: {
    async setScreenSets() {
      const res = await getScreenSets();
      this.screenSets = res.data.screen_sets;
    },
    async setMetrics() {
      const res = await getMetrics();
      this.metrics = res.data.metrics;
    },
    getProspectID() {
      const url = new URL(window.location.href);
      this.prospectID = url.searchParams.get('prospect');
    },
    async getProspect() {
      if (!this.prospectID) return null;
      const res = await fetch(`/api/v1/prospects/${this.prospectID}/`);
      const data = await res.json();

      this.prospect = data.prospect;
    },
  },
};
</script>


<style scoped>

</style>
